import { useState } from 'react';
import httpClient from 'API/httpClient';
import { Basket } from '@akyga/shared-ui';
import { ApiError } from 'types/apiError';

interface BasketFormData {
  firstName: string;
  lastName: string;
  email: string;
  company?: string;
  message: string;
  website: string;
  captchaToken?: string;
}

const useSendEmail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState<boolean | null>(null);
  const [error, setError] = useState<ApiError | null>(null);

  const formatBasketItemsToHTML = (basket: Basket) => {
    let html = '<table border="1" cellpadding="5" cellspacing="0">';
    html += '<tr><th>Product Code</th><th>Product Description</th></tr>';

    Object.keys(basket).forEach((itemCode) => {
      const { description } = basket[itemCode];
      html += `<tr>
        <td>${itemCode}</td>
        <td>${description}</td>
      </tr>`;
    });

    html += '</table>';
    return html;
  };

  const formatFormDataToHTML = (
    formData: Omit<BasketFormData, 'website' | 'captchaToken'>,
  ) => {
    const { firstName, lastName, email, company, message } = formData;

    return `
      <p><strong>First Name:</strong> ${firstName}</p>
      <p><strong>Last Name:</strong> ${lastName}</p>
      <p><strong>Email:</strong> ${email}</p>
      <p><strong>Company:</strong> ${company}</p>
      <p><strong>Message:</strong> ${message}</p>
      <p><strong>Products:</strong></p>
    `;
  };

  const sendEmail = async (formData: BasketFormData, basket: Basket) => {
    setIsLoading(true);
    setIsSuccess(null);
    setError(null);

    const { website, ...emailFormData } = formData;
    const basketHTML = formatBasketItemsToHTML(basket);
    const formHTML = formatFormDataToHTML(emailFormData);

    try {
      await httpClient.post('/send-email', {
        ...emailFormData,
        website,
        html: formHTML + basketHTML,
        subject: emailFormData.company
          ? `Inquiry form / Akyga components x ${emailFormData.company}`
          : 'Inquiry form / Akyga components',
        email: emailFormData.email,
        supportEmail: 'sales@akygacomponents.com',
      });
      setIsSuccess(true);
    } catch (err) {
      setIsSuccess(false);
      setError(err as ApiError);
    } finally {
      setIsLoading(false);
    }
  };

  return { sendEmail, isLoading, isSuccess, error };
};

export default useSendEmail;
